<template>
	<div class="projectDetail-container">
		<div class="projectDetail-content">
			<!-- vip滚动区域--start -->
			<div class="vip-container">
				<div class="vip-content">
					<div class="vip-swiper">
						<ul class="swiper-wrapper">
							<li v-for="(item, index) in vipMessages" :key="index" class="swiper-slide">
								<img src="@/assets/qualificationQuery/vip_icon.png" alt="" />
								<p>{{ item.message }}</p>
								<el-button @click="payVisible = true">立即开通</el-button>
							</li>
						</ul>
					</div>
					<div class="export-content">
						<span @click="handleExportProjectReport">
							<svg-icon icon-class="export" class="icon" />
							导出报告
						</span>
						<span
							:class="{ activeCollect: projectDetailObject.isCollect }"
							@click="handleIsCollect(projectDetailObject.id, projectDetailObject.isCollect)"
						>
							<svg-icon v-if="projectDetailObject.isCollect" icon-class="collected" class="icon" />
							<svg-icon v-else icon-class="collect" class="icon" />
							{{ projectDetailObject.isCollect ? '已收藏' : '收藏' }}
						</span>
					</div>
				</div>
			</div>
			<!-- vip滚动区域--end -->

			<!-- 表格echars--start -->
			<div class="table-container">
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4>项目详情</h4>
						</div>
						<div v-loading="projectDetailLoading" class="cjt-tabs__content">
							<div class="project-table">
								<table>
									<tr>
										<th>项目名称</th>
										<td>{{ projectDetailObject.projectName ? projectDetailObject.projectName : '/' }}</td>
										<th>项目地址</th>
										<td>{{ projectDetailObject.address ? projectDetailObject.address : '/' }}</td>
										<th>统一地址描述</th>
										<td>{{ projectDetailObject.addressDescription ? projectDetailObject.addressDescription : '/' }}</td>
									</tr>
									<tr>
										<th>统一地址识别码</th>
										<td>
											{{ projectDetailObject.addressIdentificationCode ? projectDetailObject.addressIdentificationCode : '/' }}
										</td>
										<th>项目分类</th>
										<td>{{ projectDetailObject.projectTypeName ? projectDetailObject.projectTypeName : '/' }}</td>
										<th>工程用途</th>
										<td>{{ projectDetailObject.projectPurposeName ? projectDetailObject.projectPurposeName : '/' }}</td>
									</tr>
									<tr>
										<th>项目编码</th>
										<td>{{ projectDetailObject.projectCode ? projectDetailObject.projectCode : '/' }}</td>
										<th>建设性质</th>
										<td>{{ projectDetailObject.projectPropertyName ? projectDetailObject.projectPropertyName : '/' }}</td>
										<th>所属地市州</th>
										<td>{{ projectDetailObject.cityName ? projectDetailObject.cityName : '/' }}</td>
									</tr>
									<tr>
										<th>所属区县</th>
										<td>{{ projectDetailObject.countyName ? projectDetailObject.countyName : '/' }}</td>
										<th>建设单位名称</th>
										<td>{{ projectDetailObject.constructionUnit ? projectDetailObject.constructionUnit : '/' }}</td>
										<th>唯一代码</th>
										<td>{{ projectDetailObject.constructionUnitCode ? projectDetailObject.constructionUnitCode : '/' }}</td>
									</tr>
									<tr>
										<th>总投资（万元）</th>
										<td>{{ projectDetailObject.money ? projectDetailObject.money : '/' }}</td>
										<th>总面积（平方米）</th>
										<td>{{ projectDetailObject.area ? projectDetailObject.area : '/' }}</td>
										<th>报建日期</th>
										<td>{{ projectDetailObject.constructionTime ? projectDetailObject.constructionTime : '/' }}</td>
									</tr>
									<tr>
										<th>建设规模</th>
										<td>{{ projectDetailObject.constructionScale ? projectDetailObject.constructionScale : '/' }}</td>
										<th>立项文号</th>
										<td>{{ projectDetailObject.documentCode ? projectDetailObject.documentCode : '/' }}</td>
										<th>立项级别</th>
										<td>{{ projectDetailObject.projectLevelName ? projectDetailObject.projectLevelName : '/' }}</td>
									</tr>
									<tr>
										<th>GIS经度</th>
										<td>{{ projectDetailObject.gisLon ? projectDetailObject.gisLon : '/' }}</td>
										<th>GIS维度</th>
										<td>{{ projectDetailObject.gisLat ? projectDetailObject.gisLat : '/' }}</td>
										<th></th>
										<td></td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>

				<!-- 内容导航--start -->
				<div class="project-process">
					<div class="process-box">
						<div class="process-title">
							<span>招投标阶段</span>
						</div>
						<div class="process-content">
							<div class="process-item" @click="scrollToTab('biddingTitle')">
								招投标信息
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
						</div>
					</div>
					<div class="process-box width-two blue-bg">
						<div class="process-title">
							<span>合同签约阶段</span>
						</div>
						<div class="process-content">
							<div class="process-item before-left" @click="scrollToTab('reviewTitle')">
								施工图审查
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
						</div>
					</div>
					<div class="process-box content-tow green-bg">
						<div class="process-title">
							<span>实施阶段</span>
						</div>
						<div class="process-content">
							<div class="process-item before-left" @click="scrollToTab('constructionTitle')">
								施工许可
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
							<div class="process-item before-left" @click="scrollToTab('personnelTitle')">
								现场管理人员
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
						</div>
					</div>
					<div class="process-box content-tow grass-bg">
						<div class="process-title">
							<span>验收阶段</span>
						</div>
						<div class="process-content">
							<div class="process-item before-left" @click="scrollToTab('acceptanceTitle')">
								竣工验收
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
							<div class="process-item before-left" @click="scrollToTab('recordTitle')">
								竣工验收备案
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
						</div>
					</div>
					<div class="process-box darkBlue-bg">
						<div class="process-title">
							<span>业绩评价</span>
						</div>
						<div class="process-content">
							<div class="process-item before-left" @click="scrollToTab('performanceTitle')">
								业绩技术指标
								<span class="tag-member-mini tag-member--vip">VIP</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 内容导航--end -->

				<!-- 招投标信息-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="biddingTitle">招投标信息</h4>
						</div>
						<div class="cjt-tabs__content">
							<!-- 查项目列表切换 -->
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="biddingDataList"
										:column="biddingDataColumns"
										:page-options="biddingPageOptions"
										:border="false"
										:loading="biddingLoading"
										@page-change="handleProjectBiddingPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('BiddingInformationDetails', '招投标信息详情', data.scope.row.id)"
											>
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 招投标信息-end -->

				<!-- 施工图审查-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="reviewTitle">施工图审查</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="constructionDrawingDataList"
										:column="constructionDrawingDataColumns"
										:page-options="constructionDrawingPageOptions"
										:border="false"
										:loading="constructionDrawingLoading"
										@page-change="handleConstructionDrawingPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button type="text" @click="handleOpenDialog('ReviewDetails', '施工图审查详情', data.scope.row.id)">
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 施工图审查-end -->

				<!-- 合同登记信息-start -->
				<!-- <div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="contractTitle">合同登记信息</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="contractRegisterDataList"
										:column="contractRegisterDataColumns"
										:page-options="contractRegisterPageOptions"
										:border="false"
										:loading="contractRegisterLoading"
										@page-change="handleContractRegisterPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('ContractInformation', '合同登记信息详情', data.scope.row.id)"
											>
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div> -->
				<!-- 合同登记信息-end -->

				<!-- 施工许可-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="constructionTitle">施工许可</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="constructionPermitDataList"
										:column="constructionPermitDataColumns"
										:page-options="constructionPermitPageOptions"
										:border="false"
										:loading="constructionPermitLoading"
										@page-change="handleConstructionPermitPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('ConstructionPermitDetails', '施工许可详情', data.scope.row.id)"
											>
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 施工许可-end -->

				<!-- 现场管理人员-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="personnelTitle">现场管理人员</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="projectManagePersonDataList"
										:column="projectManagePersonDataColumns"
										:page-options="projectManagePersonPageOptions"
										:border="false"
										:loading="projectManagePersonLoading"
										@page-change="handleProjectManagePersonPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<!-- 现场管理人员查看的是施工许可详情 -->
											<el-button
												type="text"
												@click="handleOpenDialog('ConstructionPermitDetails', '施工许可详情', data.scope.row.id)"
											>
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 现场管理人员-end -->

				<!-- 竣工验收-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="acceptanceTitle">竣工验收</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="projectCompletionDataList"
										:column="projectCompletionDataColumns"
										:page-options="projectCompletionPageOptions"
										:border="false"
										:loading="projectCompletionLoading"
										@page-change="handleProjectCompletionPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button type="text" @click="handleOpenDialog('AcceptanceDetails', '竣工验收详情', data.scope.row.id)">
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 竣工验收-end -->

				<!-- 竣工验收备案-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="recordTitle">竣工验收备案</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="projectCompletionAcceptanceDataList"
										:column="projectCompletionAcceptanceDataColumns"
										:page-options="projectCompletionAcceptancePageOptions"
										:border="false"
										:loading="projectCompletionAcceptanceLoading"
										@page-change="handleProjectCompletionAcceptancePageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button type="text" @click="handleOpenDialog('RecordDetails', '竣工验收备案详情', data.scope.row.id)">
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 竣工验收备案-end -->

				<!-- 业绩技术指标-start -->
				<div class="tab-container mt20">
					<div class="cjt-tabs">
						<div class="section-sub-title">
							<h4 ref="performanceTitle">业绩技术指标</h4>
						</div>
						<div class="cjt-tabs__content">
							<div>
								<div class="register-table mt20 pdm20">
									<data-table
										:table-data="projectPerformanceIndicatorDataList"
										:column="projectPerformanceIndicatorDataColumns"
										:page-options="projectPerformanceIndicatorPageOptions"
										:border="false"
										:loading="projectPerformanceIndicatorLoading"
										@page-change="handleProjectPerformanceIndicatorPageChange"
									>
										<template slot="slot_tools" slot-scope="data">
											<el-button
												type="text"
												@click="handleOpenDialog('PerformanceIndicatorDetails', '业绩技术指标详情', data.scope.row.id)"
											>
												查看详情
											</el-button>
										</template>
									</data-table>
								</div>

								<!-- 未开通会员提示 -->
								<nonbind-vip v-if="isNormalVip"></nonbind-vip>
							</div>
						</div>
					</div>
				</div>
				<!-- 业绩技术指标-end -->
			</div>
			<!-- 表格echars--start -->
			<jr-dialog :visible.sync="showDialog" :title="dialogTitle" width="70%" :append-to-body="true" :show-btn="false">
				<template v-if="showDialog" slot="content">
					<component :is="currentDialogComponent" :id="currentDialogInfoId" ref="dialogComponent"></component>
				</template>
			</jr-dialog>
		</div>

		<!-- 购买会员弹窗 -->
		<jr-dialog :visible.sync="payVisible" width="840px" :show-btn="false" @close="handleVipCancel">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>购买会员</span>
				</h4>
			</template>
			<template slot="content">
				<payment-dialog @payOrderSuccess="handlePayOrderSuccessCallback"></payment-dialog>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import JrTable from '@/components/JrTable'
	import JrDialog from '@/components/Dialog'
	import JrPagination from '@/components/Pagination'
	import RadarChart from '@/components/Chart/RadarChart.vue'
	import ProgressChart from '@/components/Chart/ProgressChart.vue'
	import PaymentDialog from '@/views/memberBenefits/paymentDialog.vue'
	import DistributionLineChart from '@/components/Chart/DistributionLineChart.vue'
	// 招投标信息详情
	import BiddingInformationDetails from './components/project/biddingInformationDetails.vue'
	// 施工图审查详情
	import ReviewDetails from './components/project/reviewDetails.vue'
	// 合同登记信息详情
	import ContractInformation from './components/project/contractInformation.vue'
	// 施工许可详情
	import ConstructionPermitDetails from './components/project/constructionPermitDetails.vue'
	// 现场管理人员详情
	import PersonnelDetails from './components/project/personnelDetails.vue'
	// 竣工验收详情
	import AcceptanceDetails from './components/project/acceptanceDetails.vue'
	// 竣工验收备案详情
	import RecordDetails from './components/project/recordDetails.vue'
	// 业绩技术指标详情
	import PerformanceIndicatorDetails from './components/project/performanceIndicatorDetails.vue'
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { mapGetters } from 'vuex'
	import { ENUM_MEMBER_BENEFIT } from '@/enum/memberBenefitRecord'
	import memberBenefitCheckerMixins from '@/mixins/memberBenefitCheckerMixins'
	import { transObject } from '@/utils/index'
	import {
		getProjectDetail,
		getProjectBiddingPage,
		getConstructionDrawingPage,
		getContractRegisterPage,
		getConstructionPermitPage,
		getProjectManagePersonPage,
		getProjectCompletionPage,
		getProjectPerformanceIndicatorPage,
		getProjectCompletionAcceptancePage,
		exportProjectReport
	} from '@/api/qualificationQuery/project'
	import { reportGenerationDownload } from '@/utils/request'
	import { COLLECT_TYPE_STATE } from '@/enum'
	import { removeUserCollect, saveUserCollect } from '@/api/userCenter'

	// 项目详情页面
	export default {
		name: 'CompanyDetail',
		components: {
			JrTable,
			JrDialog,
			JrPagination,
			RadarChart,
			ProgressChart,
			DistributionLineChart,
			BiddingInformationDetails,
			ReviewDetails,
			ContractInformation,
			ConstructionPermitDetails,
			PersonnelDetails,
			AcceptanceDetails,
			RecordDetails,
			PerformanceIndicatorDetails,
			NonbindVip,
			DataTable,
			PaymentDialog
		},
		// 使用会员权益前置校验mixins
		mixins: [memberBenefitCheckerMixins],
		props: {},
		data() {
			return {
				// 购买会员弹窗
				payVisible: false,
				showDialog: false,
				dialogTitle: '',
				currentDialogComponent: '',
				// 当前弹窗查看的信息id
				currentDialogInfoId: '',

				// 项目id
				projectId: '',

				vipMessages: [
					{ message: '李** 于3分钟前购买会员，一键解锁全部权益' },
					{ message: '王** 于5分钟前购买会员，一键解锁全部权益' },
					{ message: '张** 于10分钟前购买会员，一键解锁全部权益' }
				],

				// 项目详情加载loading
				projectDetailLoading: false,
				// 项目详情对象
				projectDetailObject: {
					id: '',
					// 项目名称
					projectName: '',
					// 项目地址
					address: '',
					// 统一地址描述
					addressDescription: '',
					// 统一地址识别码
					addressIdentificationCode: '',
					// 项目分类
					projectType: '',
					projectTypeName: '',
					// 工程用途
					projectPurpose: '',
					projectPurposeName: '',
					// 项目编码
					projectCode: '',
					// 建设性质
					projectProperty: '',
					projectPropertyName: '',
					// 所属地市州
					cityCode: '',
					cityName: '',
					// 所属区县
					countyCode: '',
					countyName: '',
					// 建设单位名称
					constructionUnit: '',
					// 唯一代码
					constructionUnitCode: '',
					// 总投资
					money: '',
					// 总面积
					area: '',
					// 报建日期
					constructionTime: '',
					// 建设规模
					constructionScale: '',
					// 数据等级
					dataLevel: '',
					// 立项文号
					documentCode: '',
					// 立项级别
					projectLevel: '',
					projectLevelName: '',
					// GIS经度
					gisLon: '',
					// GIS纬度
					gisLat: '',
					isCollect: false,
					isMonitoring: false
				},
				// 招投标信息集合
				biddingDataList: [],
				biddingDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '招标类型', prop: 'tenderTypeName', align: 'center', width: '90' },
					{ label: '招标方式', prop: 'tenderMethodName', align: 'center', width: '90' },
					{ label: '中标单位名称', prop: 'biddingUnitName', align: 'center' },
					{ label: '中标日期', prop: 'biddingDate', align: 'center', width: '110' },
					{ label: '中标金额(万元)', prop: 'biddingMoney', align: 'center' },
					{ label: '招投标环节编码', prop: 'linkCode', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				biddingLoading: true,
				// 分页配置
				biddingPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 施工图审查信息集合
				constructionDrawingDataList: [],
				constructionDrawingDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '施工图审查环节编码', prop: 'linkCode', align: 'center' },
					{ label: '勘察单位名称', prop: 'surveyingUnitName', align: 'center' },
					{ label: '设计单位名称', prop: 'designUnitName', align: 'center' },
					{ label: '施工图审查机构名称', prop: 'reviewOrgName', align: 'center' },
					{ label: '审查完成日期', prop: 'reviewFinishTime', align: 'center', width: '110' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				constructionDrawingLoading: true,
				constructionDrawingPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 合同登记信息集合
				contractRegisterDataList: [],
				contractRegisterDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '合同类型', prop: 'contractTypeName', align: 'center' },
					{ label: '合同登记编号', prop: 'contractNumber', align: 'center' },
					{ label: '合同金额(万元)', prop: 'contractMoney', align: 'center' },
					{ label: '合同签订日期', prop: 'contractSignDate', align: 'center', width: '110' },
					{ label: '承包单位名称', prop: 'contractorUnitName', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				contractRegisterLoading: true,
				contractRegisterPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 施工许可信息集合
				constructionPermitDataList: [],
				constructionPermitDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '施工许可环节编码', prop: 'constructionPermitLinkCode', align: 'center' },
					{ label: '合同金额(万元)', prop: 'contractMoney', align: 'center' },
					{ label: '面积(平方米)', prop: 'constructionArea', align: 'center' },
					{ label: '合同工期(天)', prop: 'contractWorkPeriod', align: 'center' },
					{ label: '发证日期', prop: 'makeTime', align: 'center', width: '110' },
					{ label: '状态', prop: 'remark', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				constructionPermitLoading: true,
				constructionPermitPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 现场管理人员信息集合
				projectManagePersonDataList: [],
				projectManagePersonDataColumns: [
					{ label: '人员类型', prop: 'typeName', align: 'center' },
					{ label: '姓名', prop: 'name', align: 'center' },
					{ label: '证件号码', prop: 'idCard', align: 'center' },
					{ label: '证书编号', prop: 'certificateCode', align: 'center' },
					{ label: '单位名称', prop: 'unitName', align: 'center' },
					{ label: '工程名称', prop: 'engineeringName', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				projectManagePersonLoading: true,
				projectManagePersonPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 竣工信息集合
				projectCompletionDataList: [],
				projectCompletionDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '竣工验收编号', prop: 'linkCode', align: 'center' },
					{ label: '实际造价(万元)', prop: 'actualMoney', align: 'center' },
					{ label: '实际面积(平方米)', prop: 'actualArea', align: 'center' },
					{ label: '实际开工日期', prop: 'startTime', align: 'center' },
					{ label: '实际竣工日期', prop: 'endTime', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				projectCompletionLoading: true,
				projectCompletionPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 竣工验收备案信息集合
				projectCompletionAcceptanceDataList: [],
				projectCompletionAcceptanceDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '竣工验收备案环节编码', prop: 'linkCode', align: 'center' },
					{ label: '实际造价(万元)', prop: 'actualMoney', align: 'center' },
					{ label: '实际面积(平方米)', prop: 'actualArea', align: 'center' },
					{ label: '实际开工日期', prop: 'startTime', align: 'center' },
					{ label: '实际竣工日期', prop: 'endTime', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				projectCompletionAcceptanceLoading: true,
				projectCompletionAcceptancePageOptions: {
					limit: 5,
					page: 1,
					total: 0
				},

				// 业绩技术指标信息集合
				projectPerformanceIndicatorDataList: [],
				projectPerformanceIndicatorDataColumns: [
					{ label: '数据等级', prop: 'dataLevel', align: 'center' },
					{ label: '企业名称', prop: 'companyName', align: 'center' },
					{ label: '业绩记录编号', prop: 'performanceCode', align: 'center' },
					{ label: '项目编号', prop: 'projectCode', align: 'center' },
					{ label: '业绩类型', prop: 'performanceTypeName', align: 'center' },
					{ label: '操作', prop: '', align: 'center', slot: 'slot_tools' }
				],
				projectPerformanceIndicatorLoading: true,
				projectPerformanceIndicatorPageOptions: {
					limit: 5,
					page: 1,
					total: 0
				}
			}
		},
		computed: {
			...mapGetters(['vipLevel', 'isNormalVip', 'isVip', 'isSVip'])
		},
		watch: {},
		created() {
			this.projectId = this.$route && this.$route.query?.id
		},
		mounted() {
			this.initSwiper()
			this.handleQueryProjectDetail()
			this.handleQueryProjectBiddingInfo()
			this.handleQueryConstructionDrawingInfo()
			this.handdleQueryContractRegisterInfo()
			this.handdleQueryConstructionPermitInfo()
			this.handdleQueryProjectManagePersonInfo()
			this.handdleQueryProjectCompletionInfo()
			this.handdleQueryProjectCompletionAcceptanceInfo()
			this.handdleQueryProjectPerformanceIndicatorInfo()
		},
		methods: {
			initSwiper() {
				new Swiper('.vip-swiper', {
					direction: 'vertical', // 垂直方向滚动
					loop: true, // 循环滚动
					autoplay: {
						delay: 3000, // 3秒切换一次
						disableOnInteraction: false
					},
					slidesPerView: 1, // 每次显示1条
					spaceBetween: 0 // 间距为0
				})
			},

			//  查询项目详情
			handleQueryProjectDetail() {
				this.projectDetailLoading = true
				const params = {
					projectId: this.projectId
				}

				getProjectDetail(params)
					.then(response => {
						this.projectDetailLoading = false
						const { data } = response
						// 将目标数据转为我指定的属性对象
						transObject(data, this.projectDetailObject)
					})
					.catch(error => {
						this.projectDetailLoading = false
					})
			},

			// 查询招投标信息
			handleQueryProjectBiddingInfo() {
				this.biddingLoading = true
				const params = {
					page: this.biddingPageOptions.page,
					size: this.biddingPageOptions.limit,
					projectId: this.projectId
				}

				getProjectBiddingPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.biddingDataList = data.records
							this.biddingPageOptions.total = data.total
						} else {
							this.biddingDataList = []
							this.biddingPageOptions.total = 0
						}

						this.biddingLoading = false
					})
					.catch(error => {
						this.biddingDataList = []
						this.biddingPageOptions.total = 0
						this.biddingLoading = false
					})
			},

			// 招投标信息分页查询
			handleProjectBiddingPageChange(pager) {
				const { page, limit } = pager
				this.biddingPageOptions.page = page
				this.biddingPageOptions.limit = limit
				this.handleQueryProjectBiddingInfo()
			},

			// 查询施工图审查信息
			handleQueryConstructionDrawingInfo() {
				this.constructionDrawingLoading = true
				const params = {
					page: this.constructionDrawingPageOptions.page,
					size: this.constructionDrawingPageOptions.limit,
					projectId: this.projectId
				}

				getConstructionDrawingPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.constructionDrawingDataList = data.records
							this.constructionDrawingPageOptions.total = data.total
							this.constructionDrawingLoading = false
						} else {
							this.constructionDrawingDataList = []
							this.constructionDrawingPageOptions.total = 0
							this.constructionDrawingLoading = false
						}
					})
					.catch(error => {
						this.constructionDrawingDataList = []
						this.constructionDrawingPageOptions.total = 0
						this.constructionDrawingLoading = false
					})
			},

			// 施工图审查信息分页查询
			handleConstructionDrawingPageChange(pager) {
				const { page, limit } = pager
				this.constructionDrawingPageOptions.page = page
				this.constructionDrawingPageOptions.limit = limit
				this.handleQueryConstructionDrawingInfo()
			},

			// 查询合同登记信息
			handdleQueryContractRegisterInfo() {
				this.contractRegisterLoading = true
				const params = {
					page: this.contractRegisterPageOptions.page,
					size: this.contractRegisterPageOptions.limit,
					projectId: this.projectId
				}

				getContractRegisterPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.contractRegisterDataList = data.records
							this.contractRegisterPageOptions.total = data.total
							this.contractRegisterLoading = false
						} else {
							this.contractRegisterDataList = []
							this.contractRegisterPageOptions.total = 0
							this.contractRegisterLoading = false
						}
					})
					.catch(error => {
						this.contractRegisterDataList = []
						this.contractRegisterPageOptions.total = 0
						this.contractRegisterLoading = false
					})
			},

			// 施工图审查信息分页查询
			handleContractRegisterPageChange(pager) {
				const { page, limit } = pager
				this.contractRegisterPageOptions.page = page
				this.contractRegisterPageOptions.limit = limit
				this.handdleQueryContractRegisterInfo()
			},

			// 查询施工许可信息
			handdleQueryConstructionPermitInfo() {
				this.constructionPermitLoading = true
				const params = {
					page: this.constructionPermitPageOptions.page,
					size: this.constructionPermitPageOptions.limit,
					projectId: this.projectId
				}

				getConstructionPermitPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.constructionPermitDataList = data.records
							this.constructionPermitPageOptions.total = data.total
							this.constructionPermitLoading = false
						} else {
							this.constructionPermitDataList = []
							this.constructionPermitPageOptions.total = 0
							this.constructionPermitLoading = false
						}
					})
					.catch(error => {
						this.constructionPermitDataList = []
						this.constructionPermitPageOptions.total = 0
						this.constructionPermitLoading = false
					})
			},

			// 施工许可信息分页查询
			handleConstructionPermitPageChange(pager) {
				const { page, limit } = pager
				this.constructionPermitPageOptions.page = page
				this.constructionPermitPageOptions.limit = limit
				this.handdleQueryConstructionPermitInfo()
			},

			// 查询现场管理人员信息
			handdleQueryProjectManagePersonInfo() {
				this.projectManagePersonLoading = true
				const params = {
					page: this.projectManagePersonPageOptions.page,
					size: this.projectManagePersonPageOptions.limit,
					projectId: this.projectId
				}

				getProjectManagePersonPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.projectManagePersonDataList = data.records
							this.projectManagePersonPageOptions.total = data.total
							this.projectManagePersonLoading = false
						} else {
							this.projectManagePersonDataList = []
							this.projectManagePersonPageOptions.total = 0
							this.projectManagePersonLoading = false
						}
					})
					.catch(error => {
						this.projectManagePersonDataList = []
						this.projectManagePersonPageOptions.total = 0
						this.projectManagePersonLoading = false
					})
			},

			// 现场管理人员信息分页查询
			handleProjectManagePersonPageChange(pager) {
				const { page, limit } = pager
				this.projectManagePersonPageOptions.page = page
				this.projectManagePersonPageOptions.limit = limit
				this.handdleQueryProjectManagePersonInfo()
			},

			// 查询竣工信息
			handdleQueryProjectCompletionInfo() {
				this.projectCompletionLoading = true
				const params = {
					page: this.projectCompletionPageOptions.page,
					size: this.projectCompletionPageOptions.limit,
					projectId: this.projectId
				}

				getProjectCompletionPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.projectCompletionDataList = data.records
							this.projectCompletionPageOptions.total = data.total
							this.projectCompletionLoading = false
						} else {
							this.projectCompletionDataList = []
							this.projectCompletionPageOptions.total = 0
							this.projectCompletionLoading = false
						}
					})
					.catch(error => {
						this.projectCompletionDataList = []
						this.projectCompletionPageOptions.total = 0
						this.projectCompletionLoading = false
					})
			},

			// 竣工信息分页查询
			handleProjectCompletionPageChange(pager) {
				const { page, limit } = pager
				this.projectCompletionPageOptions.page = page
				this.projectCompletionPageOptions.limit = limit
				this.handdleQueryProjectCompletionInfo()
			},

			// 查询竣工验收备案信息
			handdleQueryProjectCompletionAcceptanceInfo() {
				this.projectCompletionAcceptanceLoading = true
				const params = {
					page: this.projectCompletionAcceptancePageOptions.page,
					size: this.projectCompletionAcceptancePageOptions.limit,
					projectId: this.projectId
				}

				getProjectCompletionAcceptancePage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.projectCompletionAcceptanceDataList = data.records
							this.projectCompletionAcceptancePageOptions.total = data.total
							this.projectCompletionAcceptanceLoading = false
						} else {
							this.projectCompletionAcceptanceDataList = []
							this.projectCompletionAcceptancePageOptions.total = 0
							this.projectCompletionAcceptanceLoading = false
						}
					})
					.catch(error => {
						this.projectCompletionAcceptanceDataList = []
						this.projectCompletionAcceptancePageOptions.total = 0
						this.projectCompletionAcceptanceLoading = false
					})
			},

			// 竣工验收备案信息分页查询
			handleProjectCompletionAcceptancePageChange(pager) {
				const { page, limit } = pager
				this.projectCompletionAcceptancePageOptions.page = page
				this.projectCompletionAcceptancePageOptions.limit = limit
				this.handdleQueryProjectCompletionAcceptanceInfo()
			},

			// 查询业绩技术指标信息
			handdleQueryProjectPerformanceIndicatorInfo() {
				this.projectPerformanceIndicatorLoading = true
				const params = {
					page: this.projectPerformanceIndicatorPageOptions.page,
					size: this.projectPerformanceIndicatorPageOptions.limit,
					projectId: this.projectId
				}

				getProjectPerformanceIndicatorPage(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.projectPerformanceIndicatorDataList = data.records
							this.projectPerformanceIndicatorPageOptions.total = data.total
							this.projectPerformanceIndicatorLoading = false
						} else {
							this.projectPerformanceIndicatorDataList = []
							this.projectPerformanceIndicatorPageOptions.total = 0
							this.projectPerformanceIndicatorLoading = false
						}
					})
					.catch(error => {
						this.projectPerformanceIndicatorDataList = []
						this.projectPerformanceIndicatorPageOptions.total = 0
						this.projectPerformanceIndicatorLoading = false
					})
			},

			// 业绩技术指标信息分页查询
			handleProjectPerformanceIndicatorPageChange(pager) {
				const { page, limit } = pager
				this.projectPerformanceIndicatorPageOptions.page = page
				this.projectPerformanceIndicatorPageOptions.limit = limit
				this.handdleQueryProjectPerformanceIndicatorInfo()
			},

			// 分页
			handlePaginationChange(pager) {
				// const { page, limit } = pager
			},
			/**
			 * 打开弹窗
			 * @param type 组件名称
			 */
			async handleOpenDialog(type, title, id) {
				this.currentDialogInfoId = id
				this.currentDialogComponent = type
				this.showDialog = true
				this.dialogTitle = title
			},

			// 通用的滚动到指定tab位置的方法
			scrollToTab(name) {
				if (!name) {
					console.warn(`未找到对应ref: ${name}`)
					return
				}

				try {
					// 处理可能是数组的情况（v-for生成的ref）
					const elements = this.$refs[name]
					const element = Array.isArray(elements) ? elements[0] : elements

					if (!element) {
						console.warn(`未找到对应元素: ${name}`)
						return
					}

					this.$nextTick(() => {
						const elementPosition = element.getBoundingClientRect().top
						const scrollOffset = this.scrollOffset || 66
						const offsetPosition = elementPosition + window.pageYOffset - scrollOffset - 130

						window.scrollTo({
							top: offsetPosition,
							behavior: 'smooth'
						})
					})
				} catch (error) {
					console.error('滚动到指定位置失败:', error)
				}
			},
			handleIsCollect(id, flag) {
				// 如果项目信息还没获取出来，则直接return
				if (!id) {
					return
				}
				if (flag) {
					this.handleRemoveCollect(id)
				} else {
					this.handleCollect(id)
				}
			},
			handleCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PROJECT
				}
				saveUserCollect(params).then(res => {
					if (res.code === 200) {
						this.$message.success('收藏成功')
						this.projectDetailObject.isCollect = true
						// this.handleQueryProjectDetail()
					}
				})
			},
			handleRemoveCollect(id) {
				const params = {
					collectIds: [id],
					collectType: COLLECT_TYPE_STATE.PROJECT
				}
				removeUserCollect(params).then(res => {
					if (res.code === 200) {
						this.$message.success('已取消收藏')
						this.projectDetailObject.isCollect = false
						// this.handleQueryProjectDetail()
					}
				})
			},

			// 项目报告导出
			async handleExportProjectReport() {
				if (!this.isVip && !this.isSVip) {
					this.$message.error('暂不是高级会员，请先购买会员')
					this.payVisible = true
					return
				}

				// 前置判断资质诊断权益是否耗尽
				const isValid = await this.validateMemberBenefit(ENUM_MEMBER_BENEFIT.BGDC)
				if (!isValid) {
					return
				}

				const formData = new FormData()

				formData.append('projectId', this.projectId)

				// 执行报告生成并下载接口
				await reportGenerationDownload(exportProjectReport(), formData, {
					defaultFileName: `项目报告-${this.projectDetailObject.projectName || ''}.pdf`
				})

				this.$modal.msgSuccess('报告导出成功')
			},

			// 订单创建成功回调
			handlePayOrderSuccessCallback() {
				this.payVisible = false
				this.$router.push({
					path: '/user/market/order'
				})
			},
			handleVipCancel() {
				this.payVisible = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.projectDetail-container {
		background-color: #eff6f9;
		.projectDetail-content {
			width: $main-page-width;
			margin: 0 auto;
			padding-top: 20px;
			.information-container {
				margin-bottom: 20px;
				.information-content {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.basic-content {
						width: 1045px;
						// height: 247px;
						background-color: #ffffff;
						padding: 20px;
						.cjt-tabs__content {
							padding-top: 37px;
							display: flex;
							align-items: center;
							padding-left: 18px;
							img {
								margin-right: 40px;
							}
							.name {
								font-size: 20px;
								color: #333333;
								font-weight: bold;
								margin-bottom: 20px;
								.on-job {
									width: 106px;
									height: 28px;
									background-color: #2599fb;
									border-radius: 0px 10px 0px 10px;
									margin-left: 20px;
									font-size: 16px;
									color: #ffffff;
									text-align: center;
									line-height: 28px;
									display: inline-block;
									font-weight: normal;
								}
							}
							p {
								font-size: 16px;
								color: #333333;
								width: auto;
								display: flex;
								justify-content: space-between;
								line-height: 15px;
								margin-bottom: 15px;
							}
						}
					}
					.people-content {
						width: 335px;
						height: 290px;
						background-color: #ffffff;
						position: relative;
						.people-echarts {
							position: absolute;
							height: 90%;
							width: 100%;
							left: 0px;
							top: 17%;
						}
					}
				}
			}
			.slide-tab {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 56px;
				background-color: #236fca;
				margin-bottom: 20px;
				transition: all 0.3s ease;
				li {
					padding: 0px 19px;
					font-size: 18px;
					color: #ffffff;
					position: relative;
					text-align: center;
					line-height: 56px;
					box-sizing: border-box;
					height: 56px;
					cursor: pointer;
					.num {
						font-size: 16px;
						color: #ffffff;
						opacity: 0.5;
					}
					.vip {
						position: absolute;
						width: 33px;
						height: 18px;
						background-image: linear-gradient(90deg, #ff7e34 0%, #ffa900 100%);
						border-radius: 9px 9px 9px 0px;
						font-size: 12px;
						color: #ffffff;
						line-height: 18px;
						text-align: center;
						right: 2px;
						top: -3px;
					}
				}
				.active {
					background-color: #3a8cee;
				}
			}
			.table-container {
				position: relative;
				.table-content {
					display: flex;
					justify-content: space-between;
					.table-box {
						width: 1045px;
					}

					.charts-box {
						width: 335px;
						background-color: #fff;
						.charts-content {
							padding: 0px 15px;
							.chars-title {
								font-size: 18px;
								color: #333333;
								font-weight: bold;
								margin-top: 30px;
								position: relative;
								padding-left: 21px;
								&::before {
									display: block;
									content: '';
									width: 4px;
									height: 17px;
									background-color: #236fca;
									position: absolute;
									left: 9px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.chars-title-line {
								width: 100%;
								font-size: 18px;
								text-align: center;
								color: #333333;
								margin-top: 27px;
								position: relative;
								font-weight: bold;
								&::before {
									display: block;
									content: '';
									width: 59px;
									height: 1px;
									background: #bababa;
									position: absolute;
									left: 29px;
									top: 50%;
									transform: translateY(-50%);
								}
								&::after {
									display: block;
									content: '';
									width: 59px;
									height: 1px;
									background: #bababa;
									position: absolute;
									right: 29px;
									top: 50%;
									transform: translateY(-50%);
								}
							}
							.progress-box {
								width: 222px;
								height: 113px;
								margin: 0 auto;
								margin-top: 39px;
							}
							.discount-box {
								margin: 0 auto;
								margin-top: 60px;
								margin-bottom: 62px;
							}
							.line-box {
								width: 80%;
								margin: 0 auto;
								margin-top: 40px;
							}
						}
					}
				}
				.tab-container {
					width: 100%;
					padding: 20px 20px 0px 20px;
					background: #fff;
					.pagination-container {
						padding-top: 9px;
						padding-bottom: 12px;
					}
				}
			}
			.project-process {
				width: 100%;
				display: flex;
				position: sticky;
				top: 0;
				z-index: 100;
				background-color: #eff6f9;
				padding-top: 10px;
				margin-top: 20px;
				.process-box {
					margin-top: 20px;
					margin-right: 19px;
					&:last-child {
						margin-right: 0px;
					}
					.process-item {
						width: 160px;
						height: 51px;
						text-align: center;
						line-height: 51px;
						font-size: 16px;
						color: #ffffff;
						position: relative;
						background-color: #4bb8eb;
						z-index: 0;
						cursor: pointer;
						// 添加向右的三角形
						&::after {
							content: '';
							position: absolute;
							right: -18px; // 宽度19px
							top: 0;
							width: 0;
							height: 0;
							border-style: solid;
							border-width: 25.5px 0 25.5px 19px; // 高度51px/2=25.5px
							border-color: transparent transparent transparent #4bb8eb;
						}
						.tag-member-mini {
							position: absolute;
							height: 18px;
							line-height: 18px;
							right: 0px;
							top: -6px;
							padding: 0px 7px;
						}
					}
					.process-title {
						position: relative;
						margin-bottom: 25px;
						text-align: center;
						// 添加左右分割线
						&::before,
						&::after {
							content: '';
							position: absolute;
							top: 50%;
							width: calc(50% - 50px); // 50%减去span的近似半宽
							height: 1px;
							background-color: #4bb8eb;
						}

						&::before {
							left: 0;
						}

						&::after {
							right: 0;
						}
						span {
							display: inline-block;
							position: relative;
							z-index: 1;
							padding: 0 10px;
							background-color: #eff6f9; // 防止分割线穿透文字
							line-height: 18px;
							font-size: 18px;
							color: #4bb8eb;
						}
					}
					.before-left {
						// 添加向左的三角形
						&::before {
							content: '';
							position: absolute;
							left: 0; // 宽度19px
							top: 0;
							width: 0;
							height: 0;
							border-style: solid;
							border-width: 25.5px 19px 25.5px 0; // 高度51px/2=25.5px
							border-color: transparent #eff6f9 transparent transparent;
							transform: rotateY(180deg);
						}
					}
				}
				.width-two {
					.process-item {
						width: 306px;
					}
					.process-title {
						&::before,
						&::after {
							width: calc(32% - 5px);
						}
					}
				}
				.content-tow {
					.process-content {
						display: flex;
						.process-item {
							margin-right: 19px;
							cursor: pointer;
							&:last-child {
								margin-right: 0px;
							}
						}
					}
					.process-title {
						&::before,
						&::after {
							width: calc(39% - 5px);
						}
					}
				}
				.blue-bg {
					.process-item {
						background-color: #4b9eeb;
						&::after {
							border-color: transparent transparent transparent #4b9eeb;
						}
					}
					.process-title {
						span {
							color: #2e87d9;
						}
						&::before,
						&::after {
							background-color: #3f95e5;
						}
					}
				}
				.green-bg {
					.process-item {
						background-color: #2fb96d;
						&::after {
							border-color: transparent transparent transparent #2fb96d;
						}
					}
					.process-title {
						span {
							color: #1ea159;
						}
						&::before,
						&::after {
							background-color: #2fb96d;
						}
					}
				}
				.grass-bg {
					.process-item {
						background-color: #38c6c4;
						&::after {
							border-color: transparent transparent transparent #38c6c4;
						}
					}
					.process-title {
						span {
							color: #38c6c4;
						}
						&::before,
						&::after {
							background-color: #38c6c4;
						}
					}
				}
				.darkBlue-bg {
					.process-item {
						background-color: #015bb6;
						&::after {
							border-color: transparent transparent transparent #015bb6;
						}
					}
					.process-title {
						span {
							color: #015bb6;
						}
						&::before,
						&::after {
							background-color: #015bb6;
						}
					}
				}
			}

			.vip-title {
				font-size: 20px;
				color: #333333;
				font-weight: bold;
				padding: 25px 0px 0px 22px;
				position: relative;
				span {
					position: absolute;
					width: 33px;
					height: 18px;
					background-image: linear-gradient(90deg, #ff7e34 0%, #ffa900 100%);
					border-radius: 9px 9px 9px 0px;
					font-size: 12px;
					color: #ffffff;
					line-height: 18px;
					text-align: center;
					left: 106px;
					top: 13px;
				}
			}

			.cjt-tabs__item {
				&::after {
					height: 4px;
					background-color: #2671cb;
				}
				.cjt-tabs__item-text {
					font-size: 20px;
				}
			}
			.cjt-tabs__item.active {
				color: #333333;
			}
			.mt20 {
				margin-top: 20px;
			}
			.pdm20 {
				padding-bottom: 20px;
			}

			.project-table {
				margin-top: 20px;
				background-color: #fff;
				border-radius: 6px;
				overflow: hidden;
				padding-bottom: 20px;
				.table-title {
					width: 100%;
					padding: 15px 20px;
					background-color: #e8f4f9;
					font-size: 18px;
					font-weight: bold;
					color: #333;
					border: 1px solid #c9c9c9;
					border-bottom: none;
					border-radius: 6px 6px 0 0;
					text-align: center;
				}
				table {
					width: 100%;
					border-collapse: separate;
					border-spacing: 0;
					border: 1px solid #c9c9c9;
					border-radius: 6px;
					background-color: #ffffff;
					overflow: hidden;
					table-layout: fixed; // 添加这行

					&:not(:last-child) {
						border-bottom-left-radius: 0;
						border-bottom-right-radius: 0;
					}

					tr {
						&:not(:last-child) {
							border-bottom: 1px solid #c9c9c9;
						}
					}

					th,
					td {
						padding: 15px 20px;
						text-align: left;
						font-size: 16px;
						border-bottom: 1px solid #c9c9c9;
					}

					tr:last-child {
						th,
						td {
							border-bottom: none;
						}
					}
					th {
						width: 180px;
						background-color: #e8f4f9;
						color: #333;
						font-weight: 500;
						border-right: 1px solid #c9c9c9;
					}

					td {
						width: calc(33.33% - 180px);
						color: #666;
						line-height: 1.6;

						&:not(:last-child) {
							border-right: 1px solid #c9c9c9;
						}
					}
				}

				.expand-more {
					text-align: center;
					padding: 10px 0;
					color: #4686d2;
					cursor: pointer;
					transition: all 0.3s;
					background-color: #ffffff;
					border: 1px solid #c9c9c9;
					border-top: none;
					border-bottom-left-radius: 6px;
					border-bottom-right-radius: 6px;

					&:hover {
						background-color: #e8f4f9;
					}

					span {
						margin-right: 5px;
					}
				}

				.more-fields {
					margin-top: -4px;

					table {
						border-top-left-radius: 0;
						border-top-right-radius: 0;
					}
				}
			}
			.bt-table {
				table {
					border-top-left-radius: 0px;
					border-top-right-radius: 0px;
					th {
						width: 190px;
					}
					td {
						width: calc(33.33% - 190px);
					}
				}
			}
		}
	}
</style>
